import {
  createContext,
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from "react";
import {
  Traveler,
  TravelerPickerContextProps,
  TravelerPickerContextType,
} from "./types";
import { DEFAULT_TRAVELER_PICKER_CONTEXT } from "./constants";

const TravelerPickerContext = createContext<TravelerPickerContextType>(
  DEFAULT_TRAVELER_PICKER_CONTEXT
);

export default function TravelerPickerProvider({
  children,
  ...props
}: PropsWithChildren<TravelerPickerContextProps>) {
  const { recentPickerDataPassenger } = props;
  const [recentlyPickedTraveler, setRecentlyPickedTraveler] = useState<
    Traveler[]
  >([]);

  useEffect(() => {
    processedRecentlySearchedTravelers();
  }, [recentPickerDataPassenger]);

  function processedRecentlySearchedTravelers() {
    setRecentlyPickedTraveler(
      recentPickerDataPassenger?.map((traveler) => ({
        employeeId: traveler.id,
        fullname: traveler.fullName,
        email: traveler.email,
        division: traveler.division,
        isApprover: null,
        title: null,
        phoneCountryCode: null,
        phone: null,
        nationality: null,
        birthDate: null,
        identityCard: null,
        passportCountryOfIssue: null,
        passportExpiryDate: null,
        passportNumber: null,
        travelPolicy: null,
        travelPolicyId: null,
      })) || []
    );
  }
  return (
    <TravelerPickerContext.Provider
      value={{
        recentlyPickedTraveler,
        ...props,
      }}
    >
      {children}
    </TravelerPickerContext.Provider>
  );
}

export function useTravelerPicker() {
  const context = useContext(TravelerPickerContext);

  if (context === undefined) {
    throw new Error("`TravelerPickerContext` could not find any provider");
  }

  return context;
}
